var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-100 vertical-flex-container" }, [
    _c(
      "div",
      { staticClass: "vertical-flex-auto" },
      [
        _c(
          "b-row",
          { staticClass: "mb-2", attrs: { "no-gutters": "" } },
          [
            _c(
              "b-col",
              {
                staticClass: "pr-sm-1 text-center text-xl-left mb-lg-0 mb-3",
                attrs: { xl: "auto", lg: "2", md: "3", sm: "6" },
              },
              [
                _c(
                  "b-card",
                  { staticClass: "mb-0", attrs: { "body-class": "py-3" } },
                  [
                    _c("b-skeleton", {
                      staticClass: "px-3 mb-0",
                      attrs: { width: "5rem", height: "1.5rem" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              {
                staticClass: "small-nav-wrapper pl-sm-1",
                attrs: { xl: "", lg: "10", md: "9", sm: "6" },
              },
              [
                _c(
                  "b-card",
                  { staticClass: "mb-0", attrs: { "body-class": "py-3" } },
                  [
                    _c("b-skeleton", {
                      staticClass: "px-3 mb-0",
                      attrs: { width: "100%", height: "1.5rem" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "pr-1 vertical-flex-fit",
        attrs: { id: "app-data-container" },
      },
      [
        _c(
          "b-card",
          {
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("b-skeleton", {
                      staticClass: "px-3",
                      attrs: { width: "30%", height: "1rem" },
                    }),
                    _vm._v(" "),
                    _c("b-skeleton", {
                      staticClass: "px-3",
                      attrs: { width: "60%", height: "1rem" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "px-3",
              attrs: { width: "100%", height: "50vh" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }